import type { TourDefinition } from '../registry'
import { back, finish, gotIt, next } from '../utils/buttons'

export const accountsIntroTour: TourDefinition = {
  id: 'accounts-intro',
  displayName: 'Accounts intro',
  featureFlag: 'tour-accounts-intro',
  trigger: 'auto',
  targetPath: '/accounts',
  steps: [
    {
      id: 'welcome',
      title: 'Your account universe',
      text: 'Every company you\'re prospecting or working with — searchable, filterable, and one click away from full firmographics.',
      buttons: [gotIt],
    },
    {
      id: 'search',
      title: 'Search in plain English',
      text: 'Type a company name, or describe what you want: "manufacturers in Ohio with 200+ employees".',
      attachTo: { element: '[data-tour="accounts-search"]', on: 'bottom' },
      buttons: [back, next],
    },
    {
      id: 'view-toggle',
      title: 'Three lenses on the same data',
      text: 'List for browsing, grouped for triage, map for geographic patterns. Switch any time.',
      attachTo: { element: '[data-tour="accounts-view-toggle"]', on: 'bottom' },
      buttons: [back, next],
    },
    {
      id: 'open-account',
      title: 'Open any account',
      text: 'Click a row to see firmographics, contacts, signals, and full account history.',
      attachTo: { element: '[data-tour="accounts-list"]', on: 'top' },
      buttons: [back, finish],
    },
  ],
}
